import { Component, OnInit, AfterViewInit, OnDestroy, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  Subscription,
  BehaviorSubject,
  Observable,
  merge,
  Subject,
} from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CommonService } from 'src/app/core/services/common.service';
import { Message } from 'src/app/core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Router, ActivatedRoute } from '@angular/router';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { MatDialog } from '@angular/material';
import { ProcedureService } from 'src/app/core/services/procedure.service';
import { updateCall } from 'typescript';
import { ToastrService } from 'ngx-toastr';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { StorageService } from './../../../../../../core/services/storage.service';
import { UserEditProcedureComponent } from './user-edit-procedure/user-edit-procedure.component';
import { UserAddProcedureComponent } from './user-add-procedure/user-add-procedure.component';
import { UserViewProcedureComponent } from './user-view-procedure/user-view-procedure.component';
@Component({
  selector: 'app-user-procedure-management',
  templateUrl: './user-procedure-management.component.html',
  styleUrls: ['./user-procedure-management.component.scss']
})
export class UserProcedureManagementComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChildren('focusInput') focusInput: { first: { nativeElement: { focus: () => void; }; }; };

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  listServiceTypes: any[] = [];
  permissions: any;
  paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: [],
  }

  procedureTemplate = {
    name: null,
    type: null,
    status: null,
    page: 0,
    size: 10,
  };

  searchFilter = {
    name: null,
    type: [1, 2],
    status: [0, 1],
    userId: localStorage.getItem('userId'),
    enterpriseId: localStorage.getItem("enterpriseId"),
    page: 0,
    pageSize: 10
  }

  procedureDataSource: ProcedureDataSource;

  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: "stt", showMobile: true },
    { def: "name", showMobile: true },
    { def: "description", showMobile: true },
    { def: "type", showMobile: false },
    { def: "status", showMobile: false },
    { def: "action", showMobile: true }
  ];

  format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  documents = {
    name: '',
    type: null,
    status: null,
  };
  userType: number;
  approverNumber: any;
  sortDirection = 'ASC';
  sortColumn = 'name';
  searchProcedureForm: FormGroup;
  searchTypeCtrl: FormControl = new FormControl(null);
  loadingSearchType = false;
  listTypes: Observable<any>;
  currentPage: any
  pageSize: any


  constructor(
    public commonService: CommonService,
    public message: Message,
    private router: Router,
    public route: ActivatedRoute,
    private responsiveService: ResponsiveService,
    private dialog: MatDialog,
    private proService: ProcedureService,
    private toastr: ToastrService,
    private storageService: StorageService,
  ) {
    super(commonService, message);
    this.approverNumber = localStorage.getItem('approverNumber');
    this.permissions = localStorage.getItem('permissions');
    this.setUserType();
  }

  ngOnInit() {
    this.loadData();
    this.searchProcedureForm = new FormGroup({
      nameContains: new FormControl(this.procedureTemplate.name),
      typeContains: new FormControl(this.procedureTemplate.type ? Number(this.procedureTemplate.type) : null),
      statusEquals: new FormControl(status),
    });
  }

  ngAfterViewInit() {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }
  /**
   * Get user type from session storage and set to userType variable
   */
  setUserType() {
    this.userType = this.storageService.getUserTypeFromSessionStorage();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }

  onClickBtnFilter(page: number = 0, pageSize: number = 10) {
    let status = [];
    const tempStatus = this.searchProcedureForm.controls.statusEquals.value;
    if (tempStatus === 'DRAFT') {
      status = [0, 1];
    } else if (tempStatus === 'ACTIVE') {
      status = [1];
    } else if (tempStatus === 'INACTIVE') {
      status = [0];
    } else {
      status = [0, 1];
    }

    let type = [];
    const tempType = this.searchProcedureForm.controls.typeContains.value;
    if (tempType === '1') {
      type = [1];
    } else if (tempType === '2') {
      type = [2];
    } else {
      type = [1, 2];
    }

    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize,
    };

    this.onFilterData(
      this.searchProcedureForm.controls.nameContains.value,
      status,
      type);
  }

  focusOut(field: string) {
  }

  clearData(field: string) {
    this.searchProcedureForm.controls[field].patchValue(null);
  }

  changeStatus(element) {
    if (element.status == 1)
      element.status = 0;
    else if (element.status == 0)
      element.status = 1;
    const data = {
      procedure: element,
      procedureDetail: [],
    };
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(
        this.message.getMessage(
          'messages.confirm_change_procedure'),
        element.status == 0 ? this.message.getMessage('form.active') : this.message.getMessage('form.inactive'),
        element.status == 0 ? this.message.getMessage('form.inactive') : this.message.getMessage('form.active'),
        element.procedureName
      )
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.proService.updateProcedureStatus(data).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.change_status_procedure_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          // is parent element
          this.onFilterData(
            this.searchProcedureForm ? this.searchProcedureForm.controls.nameContains.value : null,
            this.searchProcedureForm ? this.searchProcedureForm.controls.typeContains.value : [1, 2],
            this.searchProcedureForm ? this.searchProcedureForm.controls.statusEquals.value : [0, 1]);
        });
        this.loadData()
      } else {
        if (element.status == 1)
          element.status = 0;
        else if (element.status == 0)
          element.status = 1;
      }
    });
  }

  deleteProcedure(element) {
    const data = {
      procedure: element,
      procedureDetail: [],
    };
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_procedure'), element.procedureName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.proService.deleteProcedure(data).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.delete_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          // is parent element
          this.onClickBtnFilter();
        });
      }
    });
  }

  openEditDialog(element) {
    const dialogRef = this.dialog.open(UserEditProcedureComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      autoFocus: false,
      data: {
        dataKey: element,
        approverNumber: this.approverNumber
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.onClickBtnFilter();
      this.focusInput.first.nativeElement.focus();
    });
  }

  openAddDialog(element = null) {
    const dialogRef = this.dialog.open(UserAddProcedureComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      autoFocus: false,
      data: {
        dataKey: element,
        approverNumber: this.approverNumber
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.onClickBtnFilter();
      this.focusInput.first.nativeElement.focus();
    });
  }

  openViewDialog(element) {
    const dialogRef = this.dialog.open(UserViewProcedureComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      autoFocus: false,
      data: {
        dataKey: element,
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.onClickBtnFilter();
      this.focusInput.first.nativeElement.focus();
    });
  }

  displayTooltip(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCell = document.getElementsByClassName('cell');
    if (elmsSpan.item(index).scrollWidth > elmsCell.item(index).scrollWidth) {
      return data;
    } else {
      return null;
    }
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize,
    };
    this.currentPage = page;
    this.pageSize = pageSize;
    // this.procedureTemplate.page = this.paginate.currentPage;
    // this.procedureTemplate.size = this.paginate.pageSize;
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: {
    //     ...this.procedureTemplate,
    //   },
    //   queryParamsHandling: 'merge',
    //   replaceUrl: true,
    //   skipLocationChange: false
    // });
    // // this.loadData(this.procedureTemplate);
    this.onClickBtnFilter(page, pageSize);
  }

  onFilterData(name, status, type) {
    this.proService.searchProcedure(
      {
        name: name,
        status: status,
        type: type,
        userId: localStorage.getItem('userId'),
        enterpriseId: localStorage.getItem('enterpriseId'),
        page: this.paginate.currentPage,
        pageSize: this.paginate.pageSize,
      }
    ).subscribe(response => {
      if (!response || !response.data) {
        return;
      }
      this.procedureDataSource = response.data.dataRow;
      this.paginate = {
        currentPage: response.data.currentPage,
        pageSize: response.data.pageSize,
        totalRow: response.data.totalRow,
        totalPage: Math.ceil(response.data.totalRow / response.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(response.data.totalRow / response.data.pageSize), 1),
        no: this.commonService.counter(response.data.pageSize, response.data.currentPage * response.data.pageSize + 1)
      };
    });

  }

  renderServiceType(serviceTypeId: number): string {
    const serviceType = this.listServiceTypes.find(
      (type) => type.id === serviceTypeId
    );
    if (serviceType && serviceType.name) {
      return serviceType.name;
    }
    return '';
  }

  loadData() {
    this.proService.searchProcedure({
      name: this.searchProcedureForm ? this.searchProcedureForm.controls.nameContains.value : null,
      type: this.searchProcedureForm ? this.searchProcedureForm.controls.typeContains.value : [1, 2],
      status: this.searchProcedureForm ? this.searchProcedureForm.controls.statusEquals.value : [0, 1],
      userId: localStorage.getItem('userId'),
      enterpriseId: localStorage.getItem("enterpriseId"),
      page: this.currentPage ? this.currentPage : 0,
      pageSize: this.pageSize ? this.pageSize : 10
    })
      .subscribe(response => {
        if (!response || !response.data) {
          return;
        }
        this.procedureDataSource = response.data.dataRow;
        this.paginate = {
          currentPage: response.data.currentPage,
          pageSize: response.data.pageSize,
          totalRow: response.data.totalRow,
          totalPage: Math.ceil(response.data.totalRow / response.data.pageSize),
          totalPageArray: this.commonService.counter(Math.ceil(response.data.totalRow / response.data.pageSize), 1),
          no: this.commonService.counter(response.data.pageSize, response.data.currentPage * response.data.pageSize + 1)
        };
      })
  }

}

export class Procedure {
  id: number;
  procedureName: string;
  description: string;
  type: number;
  enterpriseId: number;
  userId: number;
  status: number;
  createdBy: number;
  createAt: Date;
  updatedBy: number;
  updateAt: Date;
}

export class ProcedureDataSource extends DataSource<Procedure> {
  /** Stream of data that is provided to the table. */
  private data = new BehaviorSubject<Procedure[]>([]);
  private loading = new BehaviorSubject<boolean>(false);

  public loading$ = this.loading.asObservable();

  constructor() {
    super();
  }

  // indicate is loading
  startLoadData() {
    this.loading.next(true);
  }

  setData(data: Procedure[]) {
    /* this.data = new BehaviorSubject<DocumentType[]>(data); */
    this.data.next(data);
    this.loading.complete();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Procedure[]> {
    /* return this.data; */
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
    this.loading.complete();
  }
}

